import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vb-button-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-button-group.component.html',
  styleUrls: ['./vb-button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated
})
export class VbButtonGroupComponent {
  @Input() direction: 'horizontal' | 'vertical' = 'horizontal';
  @Input() fullWidth = false;

  get groupClasses(): string {
    const classes = ['vb-btn-group'];
    classes.push(`vb-btn-group--${this.direction}`);
    if (this.fullWidth) classes.push('vb-btn-group--full-width');
    return classes.join(' ');
  }
}
